<template>
  <div class="data">
    <div :ref="id"></div>
  </div>
</template>

<script>
  import { getChartFontSize } from '@/utils'

  export default {
    props: ['chartData', 'id'],
    data() {
      return {
        myChart: undefined,
        resizeHandler: null
      }
    },
    created() {
      this.debounceResize = _.debounce(this.resize, 200)
      this.resizeHandler = _ => {
        this.debounceResize()
      }
      window.addEventListener('resize', this.resizeHandler)
    },
    mounted() {
      this.initEchart()
    },
    methods: {
      resize() {
        try {
          this.myChart.resize()
        } catch (e) {
          console.log(e)
        }
      },
      initEchart() {
        if (this.myChart) this.myChart.dispose()
        let dom = this.$refs[this.id]
        let myChart = this.$echarts.init(dom)
        setInterval(() => {
          if (dom.clientHeight !== 0) {
            myChart.resize()
          }
        }, 200)
        this.myChart = myChart
        this.myChart.setOption(this.getOption())
      },
      getOption() {
        let option
        option = {
          legend: {
            show: false
          },
          grid: {
            top: '10%',
            left: '5%',
            right: '4%',
            bottom: '10%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: true,
              data: this.chartData.xAxis,
              axisLabel: {
                // rotate: 30,
                color: '#f8f8f8',
                fontSize: 12
              },
              axisLine: {
                lineStyle: {
                  color: '#8da4ba'
                }
              }
            }
          ],
          yAxis: [
            {
              show: true,
              type: 'value',
              min: 0,
              splitLine: {
                show: true, //是否显示网格
                lineStyle: {
                  type: 'dashed',
                  color: 'rgb(72, 122, 169)'
                }
              },
              axisLabel: {
                color: '#cecece',
                fontSize: 12
              },
              axisLine: {
                show: false
              }
            }
          ],
          series: [
            {
              name: '数量',
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(255, 255, 255, 0.1)'
              },
              barWidth: '8px',
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#39D5D3'
                  },
                  {
                    offset: 1,
                    color: '#304460'
                  }
                ])
              },
              markPoint: {
                symbol: 'rect',
                symbolSize: [16, 3], // 横线宽度和高度
                symbolOffset: [0, -1], // 向上偏移
                itemStyle: {
                  color: '#a1f9f8',
                  borderWidth: 0
                },
                data: this.chartData.yAxis.data.map((value, idx) => ({
                  xAxis: idx,
                  yAxis: value
                }))
              },
              label: {
                show: true,
                position: 'top',
                color: '#38d3d2',
                fontSize: getChartFontSize(12)
              },
              data: this.chartData.yAxis.data
            }
          ]
        }
        return option
      },
      refresh() {
        this.myChart.clear()
        this.myChart.setOption(this.getOption())
      }
    },
    watch: {
      chartData: {
        handler() {
          this.$nextTick(() => {
            this.refresh()
          })
        },
        deep: true
      }
    },
    destroyed() {
      if (this.myChart) this.myChart.dispose()
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler)
      }
      if (this.debounceResize && this.debounceResize.cancel) {
        this.debounceResize.cancel()
      }
    }
  }
</script>

<style lang="less" scoped>
  .data {
    width: 100%;
    height: 100%;
    background-size: 100%;
    div {
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spacerBar/components/alarmCharts.vue